export const formPlayersNamesInTournament = (tournament) => {
	let tournamentWithFormedPlayersNames = {}

	if (tournament?.type === 'singles') {
		const playersWithFormedNames = formeSinglePlayersNames(tournament?.players)
		tournamentWithFormedPlayersNames = {...tournament, players: playersWithFormedNames}
	} else {
		const playersWithFormedNamesIndoubles = formePlayersNamesInDouble(tournament?.doubles)
		tournamentWithFormedPlayersNames = {...tournament, doubles: playersWithFormedNamesIndoubles}
	}

	return tournamentWithFormedPlayersNames
}

const formeSinglePlayersNames = (players) => {
	const formedNames = players?.map(p => {
		const foundPlayers = players?.filter(pl => p?.last_name === pl?.last_name)
		const shortMiddleName = p?.middle_name ? `${p?.middle_name?.slice(0, 1)}.` : ''

		let formedName = null
		if (foundPlayers?.length > 1) {
			formedName = `${p?.last_name} ${p?.first_name?.slice(0, 1)}.` + shortMiddleName
		} else {
			formedName = p?.last_name
		}
		return { ...p, formedName: formedName }
	})

	return formedNames
}

const formePlayersNamesInDouble = (doubles) => {
	const playersArray = []

	doubles.forEach((double) => {
		playersArray.push(double?.player1)
		playersArray.push(double?.player2)
	})

	const formedNames = doubles?.map(d => {
		const filtredDoublesForFirstPlayer = playersArray?.filter(p => p?.last_name === d?.player1?.last_name)
		let formedFirstName = {}
		let formedSecondName = {}

		if (filtredDoublesForFirstPlayer?.length > 1) {
			const shortMiddleName = d?.player1?.middle_name ? `${d?.player1?.middle_name?.slice(0, 1)}.` : ''

			formedFirstName = {
				...d?.player1,
				formedName: `${d?.player1?.last_name} ${d?.player1?.first_name?.slice(0, 1)}.` + shortMiddleName
			}
		} else {
			formedFirstName = { ...d?.player1, formedName: d?.player1?.last_name }
		}

		const filtredDoublesForSecondPlayer = playersArray?.filter(p => p?.last_name === d?.player2?.last_name)

		if (filtredDoublesForSecondPlayer?.length > 1) {
			const shortMiddleName = d?.player2?.middle_name ? `${d?.player2?.middle_name?.slice(0, 1)}.` : ''

			formedSecondName = {
				...d?.player2,
				formedName: `${d?.player2?.last_name} ${d?.player2?.first_name?.slice(0, 1)}.` + shortMiddleName
			}
		} else {
			formedSecondName = { ...d?.player2, formedName: d?.player2?.last_name }
		}

		const updatedDouble = { ...d, player1: formedFirstName, player2: formedSecondName }
		return updatedDouble
	})
	return formedNames
}

export const checkTournamentContent = (tournament, number) => {
	if (tournament?.players?.length < 1 && number < 4) {
		return true
	} else if (tournament?.doubles?.length < 1 && number < 4) {
		return true
	} else if (tournament?.stages_count < 1 && number < 3) {
		return true
	} else {
		return false
	}
}

export const setCategoryOfTournament = (community, tournament) => {
	const category = community?.categories?.filter(c =>
		c?.uid === tournament?.category_uid
	)
	return category[0]?.name
}